import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface PatientCardModel {
  id: string;
  fullname: string;
  firstName: string;
  lastName: string;
  birthday: string | null;
  passportNumber: string;
  relationLabel: string;
  loading: boolean;
  hasDocument: boolean;
  generating: boolean;
  documentUrl: string | null;
}

@Component({
  selector: 'app-patient-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './patient-card.component.html',
  styleUrls: ['./patient-card.component.scss'],
})
export class PatientCardComponent {
  @Input({ required: true }) card!: PatientCardModel;
  @Output() generate = new EventEmitter<PatientCardModel>();

  onGenerateQrCode(): void {
    this.generate.emit(this.card);
  }

  downloadQrCode(): void {
    if (!this.card.documentUrl) return;
    const link = document.createElement('a');
    link.href = this.card.documentUrl;
    link.download = `qr-${this.card.passportNumber}.png`;
    link.click();
  }
}
